import apiClient from '../request/http-common';

class UserPaymentMethodsService {
  async getPaymentMethods() {
    try {
      const response = await apiClient.get('/api/user/payment-methods');
      return response.data;
    } catch (error) {
      console.error('Get payment methods error:', error);
      throw error;
    }
  }

  async updatePaymentMethods(paymentMethods, paymentDetails) {
    try {
      const response = await apiClient.post('/api/user/payment-methods', {
        payment_methods: paymentMethods,
        payment_details: paymentDetails
      });
      return response.data;
    } catch (error) {
      console.error('Update payment methods error:', error);
      throw error;
    }
  }
}

export default new UserPaymentMethodsService();







